import React from "react";
import { Check } from "lucide-react";
import Reveal from "./Reveal";

const POINTS = [
  "Estudio individualizado de cada caso según tipo de embarcación, situación jurídica e importe.",
  "En determinados supuestos, honorarios vinculados a la consecución de objetivos, reduciendo la inversión inicial.",
  "Costes técnicos específicos (peritajes, achatarramiento) valorados previamente cuando son necesarios.",
];

const FEES_IMG =
  "https://images.pexels.com/photos/27669996/pexels-photo-27669996.jpeg?auto=compress&cs=tinysrgb&w=2400";

const Fees = () => {
  return (
    <section
      id="honorarios"
      data-testid="section-fees"
      className="relative overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src={FEES_IMG}
          alt="Velero solitario al atardecer"
          className="w-full h-full object-cover"
          data-testid="fees-image"
        />
        {/* Diagonal gradient: dark on text side, image visible on the right */}
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy-900/75 to-navy-900/35" />
        {/* Subtle vignette */}
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/20 via-transparent to-navy-900/50" />
        <div className="absolute inset-0 grain opacity-20" />
        {/* Premium sky-glow on top-right */}
        <div className="absolute -top-1/4 -right-1/4 w-[60%] h-[140%] bg-gradient-to-bl from-sky-300/15 via-transparent to-transparent blur-3xl pointer-events-none" />
      </div>

      <div className="relative py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <Reveal>
                <div className="flex items-center gap-3 mb-5">
                  <div className="h-px w-10 bg-sky-300" />
                  <div className="text-xs uppercase tracking-[0.28em] text-sky-300 font-semibold">
                    06 — Honorarios
                  </div>
                </div>
              </Reveal>
              <Reveal delay={120}>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
                  Un modelo <span className="italic text-sky-300">flexible</span>, adaptado a cada caso.
                </h2>
              </Reveal>
            </div>
            <div className="lg:col-span-7 space-y-6">
              <Reveal delay={150}>
                <p className="text-base lg:text-lg text-white/85 leading-relaxed">
                  Cada caso se estudia de forma individual en función del tipo de embarcación,
                  situación jurídica, importe de la deuda y actuaciones necesarias.
                </p>
              </Reveal>
              <Reveal delay={200}>
                <p className="text-base lg:text-lg text-white/85 leading-relaxed">
                  En determinados supuestos, los honorarios pueden vincularse a la consecución de
                  objetivos, reduciendo la necesidad de inversión inicial por parte del puerto o
                  marina.
                </p>
              </Reveal>
              <Reveal delay={250}>
                <p className="text-base lg:text-lg text-white/85 leading-relaxed">
                  Los costes técnicos específicos, como peritajes o achatarramiento, se valoran
                  previamente cuando resultan necesarios.
                </p>
              </Reveal>

              <div className="mt-10 grid sm:grid-cols-1 gap-4 pt-6 border-t border-white/20">
                {POINTS.map((p, idx) => (
                  <Reveal key={idx} delay={300 + idx * 100}>
                    <div
                      data-testid={`fee-point-${idx}`}
                      className="group flex gap-4 items-start bg-white/[0.04] backdrop-blur-md border border-white/15 hover:border-sky/40 hover:bg-white/[0.08] px-5 py-4 rounded-sm transition-all duration-500"
                    >
                      <div className="flex-shrink-0 w-7 h-7 rounded-full bg-sky text-navy-900 flex items-center justify-center mt-0.5 group-hover:scale-110 transition-transform">
                        <Check size={14} strokeWidth={2.5} />
                      </div>
                      <p className="text-white/90 text-sm lg:text-[15px] leading-relaxed">{p}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Fees;
